import { render } from "./PolicyFooter.vue?vue&type=template&id=e027cf9e"
import script from "./PolicyFooter.vue?vue&type=script&lang=js"
export * from "./PolicyFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__